import { BannerAd } from "@src/types/BannerAd";

export type AdsBannerProps = {
  adsData: BannerAd;
  onClose: () => void;
};

export enum BannerActionEnum {
  view = "0",
  clickThrough = "1",
  cancel = "2",
  skip = "3",
}

export enum MediaPurpose {
  BANNER = "banner",
  MODAL = "modal",
  GRID = "grid",
  LIST = "list",
  LIST_IPAD = "list_ipad",
}
